define.alias("shared/components/shared/mobile/drawer/layout", "settings/components/shared/mobile/drawer/layout");